export const GLOBAL_NAV = [
  { id: "home", labelFr: "Accueil", labelEn: "Home", href: "/capital" },
  {
    id: "market",
    labelFr: "Marché",
    labelEn: "Market",
    children: [
      { id: "flux", labelFr: "Flux", labelEn: "Flow", href: "/marketflow" },
      { id: "leaders", labelFr: "Leaders", labelEn: "Leaders", href: "/" },
    ],
  },
  { id: "strategies", labelFr: "Stratégies", labelEn: "Strategies", href: "/capital/strategies" },
  { id: "screener", labelFr: "Screener", labelEn: "Screener", href: "/capital/screener" },
];

export function navLabel(item, language) {
  return language === "en" ? item.labelEn : item.labelFr;
}

export function searchPlaceholder(language) {
  return language === "en" ? "Symbol..." : "Symbole...";
}

export function searchingLabel(language) {
  return language === "en" ? "Searching..." : "Recherche...";
}

export function noResultsLabel(language) {
  return language === "en" ? "No results" : "Aucun résultat";
}
